import React from 'react';
import { PropTypes } from 'prop-types';

import { buildDescription } from 'components/IndividualValidationResult';

/* eslint-disable react/no-array-index-key */
export const ReasonsForRejectionCellRenderer = ({ value: rejections }) => (
  <div className="reasons-for-rejection-list">
    { rejections != null && rejections.length === 0 && <span>N/A</span> }
    { rejections != null && rejections.length !== 0 && <ul>
      { rejections.map(rejection => rejection != null && (
        <li key={ rejection.key }>
          { buildDescription(rejection) }
          &nbsp;({ rejection.code })
        </li>
      )) }
    </ul> }
  </div>
);
/* eslint-enable react/no-array-index-key */

ReasonsForRejectionCellRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    codeDescription: PropTypes.string,
    context: PropTypes.shape({}),
    key: PropTypes.string
  })).isRequired
};

export function getReasonsForRejectionForFilter({ value: rejections }) {
  return (
    rejections != null && rejections.map(({ code, codeDescription }) => code != null && codeDescription != null && (
      `${ code } ${ codeDescription }`
    )).join(' ')
  );
}
